<h2 mat-dialog-title class="hidden-dialog-title">
    <mat-icon>visibility_off</mat-icon>
    <span>Ausgeblendete Termine</span>
    <span class="hidden-dialog-count" *ngIf="!loading && events.length > 0">{{ events.length }}</span>
</h2>

<mat-dialog-content class="hidden-dialog-content">

    <p class="hidden-dialog-hint">
        Diese Outlook-Termine werden in der Planung nicht angezeigt. Sie bleiben in Outlook
        unverändert und können jederzeit wieder eingeblendet werden.
    </p>

    <!-- Laden -->
    <div class="hidden-dialog-state" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
        <span>Ausgeblendete Termine werden geladen …</span>
    </div>

    <!-- Fehler -->
    <div class="hidden-dialog-state hidden-dialog-error" *ngIf="!loading && loadError">
        <mat-icon>error_outline</mat-icon>
        <span>{{ loadError }}</span>
        <button mat-stroked-button type="button" (click)="load()">Erneut versuchen</button>
    </div>

    <!-- Leerzustand -->
    <div class="hidden-dialog-empty" *ngIf="!loading && !loadError && events.length === 0">
        <mat-icon>visibility</mat-icon>
        <strong>Keine ausgeblendeten Termine</strong>
        <span>Alle Outlook-Termine werden in der Planung angezeigt.</span>
    </div>

    <!-- Liste -->
    <ul class="hidden-list" *ngIf="!loading && events.length > 0">
        <li class="hidden-item" *ngFor="let event of events; trackBy: trackEvent"
            [class.busy]="busyId === event.id || busyAll">

            <div class="hidden-item-main">
                <div class="hidden-item-title">{{ event.title || 'Outlook-Termin' }}</div>

                <div class="hidden-item-meta">
                    <mat-icon>person</mat-icon>
                    <span>{{ employeeName(event.userId) }}</span>
                </div>

                <div class="hidden-item-meta">
                    <mat-icon>event</mat-icon>
                    <span>{{ formatPeriod(event) }}</span>
                </div>
            </div>

            <button mat-icon-button type="button" class="hidden-item-restore"
                matTooltip="Wieder einblenden" aria-label="Wieder einblenden"
                [disabled]="busy" (click)="restore(event)">
                <mat-icon>visibility</mat-icon>
            </button>
        </li>
    </ul>

</mat-dialog-content>

<mat-dialog-actions align="end" class="hidden-dialog-actions">
    <button mat-button type="button" [disabled]="busy" (click)="close()">Schließen</button>
    <button mat-flat-button color="primary" type="button"
        [disabled]="loading || busy || events.length === 0" (click)="restoreAll()">
        <mat-icon>visibility</mat-icon>
        Alle einblenden
    </button>
</mat-dialog-actions>
